import { VerifyBadge } from './CertBlock';

interface MainProductBlockProps {
  show: boolean;
  mainProduct: string[] | null;
}
export const MainProductBlock = ({ show, mainProduct }: MainProductBlockProps) => {
  if (!show) return null;
  const mainProductStr = mainProduct?.join(', ');
  return (
    <div className=" flex overflow-hidden w-full items-center mt-3 gap-2">
      <VerifyBadge />
      <div className="h-[21px]  flex-[1_0_0] text-[color:var(--500-fill--,#737373)] [font-family:Geist] text-sm font-normal leading-[150%] tracking-[0.07px] truncate">
        Main product: {mainProductStr || '-'}
      </div>
    </div>
  );
};
